import { useState } from "react";
import { Button, Card, Col, Row } from "react-bootstrap";
import HyperledgerBesu from "../../assets/images/hyperledger-besu.svg"
import Binance from "../../assets/images/binance.svg"
import Avalanche from "../../assets/images/avalanche.svg"
import Algorand from "../../assets/images/algorand.svg"

const Blockchain = () => {
    const [modal, setModal] = useState(false);
    const [stepFirst, setStepFirst] = useState(true);
    // const [step, setStep] = useState(1);

    const handleModal = () => {
        setModal(!modal);
    }
    return ( 
        <>

        <Card className="card-dark mb-3">
            <Card.Body className="p-4">
                <Row className="align-items-center">
                    <Col sm={8} className="mb-sm-0 mb-3">
                        <h4>Blockchain network</h4>
                        <p>Set up a permissioned network or join a public network.</p>
                    </Col>
                    
                    <Col sm={4} className="text-center text-sm-end">
                        {localStorage.getItem('Login') === true || localStorage.getItem('Login') || localStorage.getItem('Login') ==="true" ?(<>
                            <Button onClick={handleModal}>Configure</Button>
                           
                        </>):(<>
                        
                            <Button  disabled onClick={handleModal}>Configure</Button>
                        </>)}
                        
                    </Col>
                </Row>
            </Card.Body>
        </Card>
        
        <div className={`modal-outer ${modal ? 'active' : ''}`}>
                <div class="modal-overlay"></div>
                <div className="modal_content">
                    <button className="btn_close" onClick={handleModal}>
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" aria-hidden="true"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path></svg>
                    </button>
                        <div className="modal-section">
                            <div className="mb-5">
                                <h3 className="mb-4">Select a blockchain network for your nodes</h3>

                                <h5>Select your network preference</h5>
                                <p>You can choose the blockchain network which your nodes will run on. <a href="/">Learn more</a></p>
                            </div>
                            <Row>
                                <Col md={4} className="mb-4">
                                    <h6 className="mb-3">Private network</h6>

                                    <Row>
                                        <Col md={12} sm={6} className="mb-3">
                                            <label className="label-card">
                                                <input type="radio" hidden name="network-preference" onChange={() => setStepFirst(false)} />
                                                <span className="d-flex justify-content-center align-items-center">
                                                    <span className="me-2"><img src={Binance} alt="Sidechain" /></span>
                                                    <span className="label-card-name">BSC sidechain</span>
                                                </span>
                                            </label>
                                        </Col>
                                        {/* <Col md={12} sm={6} className="mb-3">
                                            <label className="label-card">
                                                <input type="radio" hidden name="network-preference" onChange={() => setStepFirst(false)} />
                                                <span className="d-flex justify-content-center align-items-center">
                                                    <span className="me-2"><img src={HyperledgerBesu} alt="HyperledgerBesu" /></span>
                                                    <span className="label-card-name">Hyperledger Besu</span>
                                                </span>
                                            </label>
                                        </Col>
                                        <Col md={12} sm={6} className="mb-3">
                                            <label className="label-card">
                                                <input type="radio" hidden name="network-preference" onChange={() => setStepFirst(false)} />
                                                <span className="d-flex justify-content-center align-items-center">
                                                    <span className="me-2"><img src={HyperledgerBesu} alt="HyperledgerBesu" /></span>
                                                    <span className="label-card-name">Hyperledger Besu</span>
                                                </span>
                                            </label>
                                        </Col> */}
                                    </Row>
                                </Col>
                                {/* <Col md={4} className="mb-4">
                                    <h6 className="mb-3">Public network - Mainnet</h6>

                                    <Row>
                                        <Col md={12} sm={6} className="mb-3">
                                            <label className="label-card">
                                                <input type="radio" hidden name="network-preference" onChange={() => setStepFirst(false)} />
                                                <span className="d-flex justify-content-center align-items-center">
                                                    <span className="me-2"><img src={HyperledgerBesu} alt="HyperledgerBesu" /></span>
                                                    <span className="label-card-name">Hyperledger Besu</span>
                                                </span>
                                            </label>
                                        </Col>
                                        <Col md={12} sm={6} className="mb-3">
                                            <label className="label-card">
                                                <input type="radio" hidden name="network-preference" onChange={() => setStepFirst(false)} />
                                                <span className="d-flex justify-content-center align-items-center">
                                                    <span className="me-2"><img src={Binance} alt="Binance" /></span>
                                                    <span className="label-card-name">Binance Smart Chain</span>
                                                </span>
                                            </label>
                                        </Col>
                                        <Col md={12} sm={6} className="mb-3">
                                            <label className="label-card">
                                                <input type="radio" hidden name="network-preference" onChange={() => setStepFirst(false)} />
                                                <span className="d-flex justify-content-center align-items-center">
                                                    <span className="me-2"><img src={Binance} alt="Binance" /></span>
                                                    <span className="label-card-name">Binance Smart Chain</span>
                                                </span>
                                            </label>
                                        </Col>
                                    </Row>
                                </Col> */}
                                <Col md={4} className="mb-4">
                                    <h6 className="mb-3">Public network - Testnet</h6>

                                    <Row>
                                        <Col md={12} sm={6} className="mb-3">
                                            <label className="label-card">
                                                <input type="radio" hidden name="network-preference" onChange={() => setStepFirst(false)} />
                                                <span className="d-flex justify-content-center align-items-center">
                                                    <span className="me-2"><img src={Binance} alt="Binance" /></span>
                                                    <span className="label-card-name">BSC Testnet</span>
                                                </span>
                                            </label>
                                        </Col>
                                        <Col md={12} sm={6} className="mb-3">
                                            <label className="label-card">
                                                <input type="radio" hidden name="network-preference" onChange={() => setStepFirst(false)} />
                                                <span className="d-flex justify-content-center align-items-center">
                                                    <span className="me-2"><img src={Algorand} alt="Algorand" /></span>
                                                    <span className="label-card-name">Algorand</span>
                                                </span>
                                            </label>
                                        </Col>
                                        {/* <Col md={12} sm={6} className="mb-3">
                                            <label className="label-card">
                                                <input type="radio" hidden name="network-preference" onChange={() => setStepFirst(false)} />
                                                <span className="d-flex justify-content-center align-items-center">
                                                    <span className="me-2"><img src={HyperledgerBesu} alt="HyperledgerBesu" /></span>
                                                    <span className="label-card-name">Hyperledger Besu</span>
                                                </span>
                                            </label>
                                        </Col> */}
                                    </Row>
                                </Col>
                            </Row>

                            <div className="d-flex align-items-center justify-content-end">
                                <Button onClick={handleModal} variant="outline-primary me-3">Close</Button>
                                <Button onClick={handleModal} disabled={stepFirst}>Confirm</Button>
                            </div>
                        </div>


                </div>
            </div>
        </>
     );
}
 
export default Blockchain;